// ABOUTME: Calculates unread WhatsApp counts for applicant and segment identities.
// ABOUTME: Keeps global badges and conversation-level badges aligned with inbox identity.
export interface WhatsappUnreadConversation {
    applicantId?: string;
    segmentId?: string;
    scope?: string;
    contactEpisodeId?: string;
    unreadCount: number;
}

export interface WhatsappUnreadSummary {
    featureEnabled: boolean;
    connected: boolean;
    canSendMessages: boolean;
    totalUnread: number;
    pendingCount: number;
    conversations: WhatsappUnreadConversation[];
}

export const normalizeWhatsappUnreadSummary = (
    value: Compleo.IObject = {}
): WhatsappUnreadSummary => ({
    featureEnabled: value.featureEnabled === true,
    connected: value.connected === true,
    canSendMessages: value.canSendMessages === true,
    totalUnread: Number(value.totalUnread || 0),
    pendingCount: Number(value.pendingCount || 0),
    conversations: Array.isArray(value.conversations) ? value.conversations : []
});

export const getWhatsappUnreadCount = (
    conversations: WhatsappUnreadConversation[],
    applicantId?: string,
    segmentId?: string
) => {
    const selectedSegmentId = String(segmentId || "").trim();
    const selectedApplicantId = String(applicantId || "").trim();

    return conversations.reduce((total, conversation) => {
        const matches = selectedSegmentId
            ? String(conversation.segmentId || "") === selectedSegmentId
            : selectedApplicantId &&
              !String(conversation.segmentId || "").trim() &&
              String(conversation.applicantId || "") === selectedApplicantId;

        return matches ? total + Number(conversation.unreadCount || 0) : total;
    }, 0);
};
